import { SearchComponent } from "./search-component";

export abstract class SelectableSearchComponent<T> extends SearchComponent<T> {
  public showSelectedResults = false;

  public selectedResults: Map<any, T> = new Map();

  public hideSelected() {
    return this.showSelectedResults = false;
  }

  public isSelected(key: any) {
    return this.selectedResults.has(key);
  }

  public selectedCount(): number {
    return this.selectedResults.size;
  }

  public showSelected() {
    return this.showSelectedResults = true;
  }

  public toggleSelected(key: any, result: T) {
    if (this.isSelected(key)) {
      this.selectedResults.delete(key)
    } else {
      this.selectedResults.set(key, result);
    }
  }
}